import { render, staticRenderFns } from "./OrderDetailPopup.vue?vue&type=template&id=316d52c9"
import script from "./OrderDetailPopup.vue?vue&type=script&lang=js"
export * from "./OrderDetailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports